import { render, staticRenderFns } from "./Configuration.vue?vue&type=template&id=aae08fe2&scoped=true&"
import script from "./Configuration.vue?vue&type=script&lang=js&"
export * from "./Configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aae08fe2",
  null
  
)

export default component.exports